// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1oXhe","errorLogs":"EditorFooter_errorLogs__2Pn5_"};